module.exports = __webpack_public_path__ + "static/media/user-01-web.77ebdc95.png";